module.exports = __webpack_public_path__ + "media/assets/community_index/chevron_right-9174b24a554dacd729648f471675fe95c315ef7b71357204ed54f5eba37fbf7c.svg";